var app;

app = window.App || (window.App = {});

app.InvitationLists = {
  updatePath: function(e) {
    var event, form, metaToken;
    event = JSON.parse(e);
    form = $('form#new_event_invitation')[0];
    $("#new_event_invitation button[type='submit']").prop('disabled', false);
    form.action = form.action.replace('/-1/', "/" + event['id'] + "/");
    metaToken = $('meta[name=csrf-token]')[0].content;
    form.elements['authenticity_token'].value = metaToken;
    app.InvitationLists.resetOptions(event.types);
    return event.label;
  },
  resetOptions: function(types) {
    var select;
    select = $('#role_type');
    if (types.length === 0) {
      select.hide();
      return;
    }
    select.show();
    select.empty();
    return $.each(types, function(_index, type) {
      select.append($('<option></option>').attr('value', type.name).text(type.label));
    });
  }
};
